export default (variant, quantity = 0) => {
  if (!variant) {
    return 0
  }
  const available = variant.availableForSale
  const quantityAvailable = variant.quantityAvailable
  if (!available) {
    return 0
  }
  if (typeof quantityAvailable !== 'number') {
    return quantity
  }
  return quantity ? Math.min(quantity, quantityAvailable) : quantityAvailable
}
